import { render } from "./XIconButton.vue?vue&type=template&id=7e110d7c&scoped=true"
import script from "./XIconButton.vue?vue&type=script&lang=js"
export * from "./XIconButton.vue?vue&type=script&lang=js"

import "./XIconButton.vue?vue&type=style&index=0&id=7e110d7c&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e110d7c"]])

export default __exports__